import api from './api';

export const getTodayStatus = () => api.get('/shifts/today');
export const getBusinessDate = () => api.get('/shifts/business-date');
export const getClosedDays = (params) => api.get('/shifts/closed', { params });
export const getShifts = (params) => api.get('/shifts', { params });
export const closeDaySession = () => api.post('/shifts/close');
export const startNewDaySession = () => api.post('/shifts/start');